<template>
  <el-dialog title="查看样本信息" :visible.sync="showDialog" width="80%" :destroy-on-close="true" :append-to-body="true"
             :before-close="cancel">
    <div v-loading="loading">
      <w-table class="wMyTable" ref="wMyTable" :columns="columns" :table-data="tableData"
               :isPagination="true" :is-use-inner-page=true :is-use-inner-search="true" :isExcludeRoutePath="true">
        <!--          样品合格-->
        <div slot="qualified" slot-scope="{text, record,index}">
          <el-tag v-if="text" type="success">合格</el-tag>
          <el-tag v-else type="danger">不合格</el-tag>
        </div>
      </w-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancel">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getSampleInfo} from "@/api/dilivery/sampleInfo";
import {sampleTableCol} from "@/utils/data/tableCol/sampleTableCol";
import {projectSampleInfo} from "@/api/singleCell";

export default {
  name: "SampleInfoDialog",
  props: {
    showDialog: {
      default: false
    },
    selectDetail: {
      default: () => ({})
    }
  },

  data() {
    return {
      tableData: [],
      loading:false,
    }
  },
  computed: {
    columns() {
      return sampleTableCol([]);
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = {
        platform: this.selectDetail.platform,
        projectId: this.selectDetail.projectId
      }
      let res
      if (params.platform === 'platform') {
        res = await projectSampleInfo(params.projectId)
      } else {
        res = await getSampleInfo(params)
      }
        if (res?.code === 200) {
          this.loading = false
          if (this.selectDetail.isNeedFilterSample) {
            this.tableData = res.data.filter(item => this.selectDetail.sampleNameList.includes(item.sampleName))
          } else {
            this.tableData = res.data
          }
        }
    },
    cancel() {
      this.$emit('update:showDialog')
    },
    handle() {
      this.$emit('submitData')
    },
  },
}
</script>

<style scoped>


</style>
